// web/src/services/mockUsersService.js

import { calculateAge } from "./matchEngine";

//
// 🔥 MOCK REALISTA DE USUÁRIOS
// ----------------------------------------------------------
// Totalmente baseado no fluxo real do app One Love
// Inclui:
// - gênero
// - quem busca (searchGender)
// - aceita outra cidade (acceptsOtherCities)
// - estilos de vida e interesses
// - status
// - plano
// - fotos
// - bloqueios (blockedUsers)
// - datas de criação e atividade
//

export const mockUsers = [
  {
    id: "user_ana",
    name: "Ana Souza",
    email: "ana@example.com",
    city: "Curitiba",
    gender: "feminino",
    searchGender: "masculino",      // quem ela busca
    acceptsOtherCities: false,
    birthdate: "1998-04-12",

    lifestyleTags: [
      "vida_saudavel",
      "espiritualidade",
      "musculacao"
    ],

    plan: "starter",
    status: "ativo",

    photos: [], 
    blockedUsers: [],

    createdAt: "2025-01-02",
    lastActiveAt: "2025-02-18",
  },

  {
    id: "user_bruno",
    name: "Bruno Lima",
    email: "bruno@example.com",
    city: "Curitiba",
    gender: "masculino",
    searchGender: "feminino",
    acceptsOtherCities: true,
    birthdate: "1995-08-20",

    lifestyleTags: [
      "trabalho_remoto",
      "vida_saudavel",
      "corrida"
    ],

    plan: "mensal",
    status: "ativo",

    photos: [],
    blockedUsers: [],

    createdAt: "2025-01-15",
    lastActiveAt: "2025-02-14",
  },

  {
    id: "user_carla",
    name: "Carla Mendes",
    email: "carla@example.com",
    city: "São Paulo",
    gender: "feminino",
    searchGender: "masculino",
    acceptsOtherCities: true,
    birthdate: "2000-02-05",

    lifestyleTags: [
      "yoga",
      "espiritualidade",
      "arte"
    ],

    plan: "free",
    status: "ativo",

    photos: [],
    blockedUsers: [],

    createdAt: "2025-01-10",
    lastActiveAt: "2025-02-16",
  },

  {
    id: "user_diego",
    name: "Diego Santos",
    email: "diego@example.com",
    city: "São Paulo",
    gender: "masculino",
    searchGender: "feminino",
    acceptsOtherCities: true,
    birthdate: "1996-11-10",

    lifestyleTags: [
      "vida_saudavel",
      "corrida",
      "musculacao"
    ],

    plan: "mensal",
    status: "ativo",

    photos: [],
    blockedUsers: [],

    createdAt: "2025-01-12",
    lastActiveAt: "2025-02-20",
  },

  {
    id: "user_eduarda",
    name: "Eduarda Nogueira",
    email: "eduarda@example.com",
    city: "Belo Horizonte",
    gender: "feminino",
    searchGender: "masculino",
    acceptsOtherCities: false,
    birthdate: "1995-07-21",

    lifestyleTags: [
      "leitura",
      "arte"
    ],

    plan: "starter",
    status: "ativo",

    photos: [],
    blockedUsers: [],

    createdAt: "2025-01-25",
    lastActiveAt: "2025-02-17",
  },

  {
    id: "user_felipe",
    name: "Felipe Costa",
    email: "felipe@example.com",
    city: "Curitiba",
    gender: "masculino",
    searchGender: "feminino",
    acceptsOtherCities: true,
    birthdate: "1993-03-30",

    lifestyleTags: [
      "musculacao",
      "viajar"
    ],

    plan: "free",
    status: "ativo",

    photos: [],
    blockedUsers: [],

    createdAt: "2025-01-18",
    lastActiveAt: "2025-02-19",
  },
];



//
// 🔥 Adiciona o campo "age" calculado automaticamente
// ----------------------------------------------------------
// Painel depende desse campo para exibir idade corretamente
//

export function getMockUsersWithAge() {
  return mockUsers.map((u) => ({
    ...u,
    age: calculateAge(u.birthdate),
  }));
}



//
// 🔥 Padroniza os labels do plano
// ----------------------------------------------------------
// Exemplo: "starter" → "Starter"
//

export function getPlanLabel(plan) {
  if (!plan) return "Plano indefinido";

  const mapping = {
    free: "Free",
    starter: "Starter",
    mensal: "Mensal",
    mensalidade: "Mensal",
    premium: "Premium",
    anual: "Anual",
    annual: "Anual",
    monthly: "Mensal",
  };

  return mapping[plan] ?? plan;
}
